/** eslint-disable **/
import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as messageActionCreators from "../../action-creators/message-actions";
import * as modalActionCreators from "../../action-creators/modal-actions";
import "./styles.css";
import classNames from "classnames";
import Message from "../../models/message";
import TextBlock from "../../components/text-block";
import Page from "../../components/page";
import { search } from "../../libs/utilities";
import SearchBar from "../../components/search-bar";
import * as modals from "../../constants/modals";
import queryString from "query-string";
import Layout from "../../components/layout";
import type User from "../../models/user";


type RowDatumType = {
    onToggleUser: (uid: string, event: Object) => void,
    user: Object,
    id: string,
    isSelected: boolean
};

const RowTemplate = ({ onToggleUser, user, id, isSelected }: RowDatumType): React.Component => (
    <button className={classNames("messages--row", { selected: isSelected })} onClick={onToggleUser}>
        <span className={"messages--row-avatar"}
            style={{ backgroundImage: `url("${user.photoURL}")` }} />

        <span>
            <span className={"messages--row-description"}>
                <span className={"messages--row-description-name"}>{user.displayName}</span>
                <span className={"messages--row-description-email"}>{user.email}</span>
            </span>
        </span>
    </button>
);


type PropsType = { actions: { [string]: any => void }, users: User[], user: session.user, messages: messages };


const MyScreen = ({ actions, users, user, messages }: PropsType) => {
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [message, setMessage] = useState("");

    console.log(user)
    console.log(messages.success)

    const sendMessage = () => {

        const myMessage = Message.create({ text: message, sender: user, read: true });

        const recipients = selectedUsers.map(userIndex => users[userIndex]).filter(id => Boolean(id));        
        recipients.forEach(recipient => {             
            recipient.displayName ? myMessage.recipient = recipient.displayName : myMessage.recipient = recipient.email          
            actions.sendUserMessage(recipient.uid, myMessage)
        });
        
        setMessage("");
        setSelectedUsers([]);
    };

    const headerContent = (
        <button className="towns--header-button" onClick={sendMessage}>
            {"Send"}
        </button>
    );

    const toggleUser = (uid: string) => () => {
        const isNotSelected = selectedUsers.indexOf(uid) === -1;
        const newSelectedUsers = isNotSelected
            ? [].concat(selectedUsers, uid)
            : selectedUsers.filter(userId => userId !== uid);
        setSelectedUsers(newSelectedUsers);
    };

    const data = search(Object
        .entries(users)
        .filter(entry => Boolean(entry[1])), queryString.parse(window.location.search).search)
        .map(entry => ({
            onToggleUser: toggleUser(entry[0]),
            user: entry[1],
            id: entry[0],
            isSelected: (selectedUsers.indexOf(entry[0]) !== -1)
        })
        );

    const ToolBar = () => (
        <div className={"messages--toolbar"}>
            <div>
                <button
                    className={"messages--new-message-button"}
                    onClick={() => actions.openModalExclusively(modals.MAIN_SIDE_PANEL)}
                >
                    {"New"}
                </button>
            </div>
            <div><SearchBar onSearch={search} /></div>
        </div>
    );

    return (

        <Page RowTemplate={RowTemplate}
            data={data}
            headerContent={headerContent}
            onRowSelect={() => null} // override default behavior
            onSearch={search}
            pagination={false}
            toolbar={<ToolBar />}
        >
            <div className={"messages--new-message"}>
                { messages.success !== null ? <div className={ "messages--success" } style={ {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    background: "lightgray",
                    height: "200px",
                    width: "200px",
                    fontSize: "3rem",
                    margin: "20rem 70rem"
                 } } >
                   { messages.success === true ? <div> Message sent successfully <button onClick={actions.resetUserMessage}>OK</button></div> : null } 
                   { messages.success === false ? <div> Failed to send message <button onClick={actions.resetUserMessage}>OK</button></div> : null }
                </div> : null }
                <TextBlock className={"messages--new-message-text-block"} labelText={"message"}
                    onChange={setMessage}
                    value={message} />
            </div>
        </Page>

    );
};

const mapStateToProps = (state: Object): Object => {
    const users = Object.values((state.users || {}).data || {});
    const user = (state.users || { data: {} }).data[state.session.user.uid] || { photoURL: state.session.user.photoURL };
    const messages = state.messages 
    return ({ users, user, messages });
};

const mapDispatchToProps = (dispatch): Object => ({
    actions: bindActionCreators({ ...messageActionCreators, ...modalActionCreators }, dispatch)
});

export const MessagesScreen = connect(mapStateToProps, mapDispatchToProps)(MyScreen);
